<app-header-public class="sticky top-0 z-[100]"></app-header-public>
<main class="relative flex-grow">
    <ng-content></ng-content>
</main>
<app-public-footer />
